import { createContext } from "react";

import type { ApiCallers } from "@core/ports/http";

import type { githubApi, oauthApi } from "@apis/account/api";
import type { busApi } from "@apis/bus/api";
import type { generationApi } from "@apis/generation/api";
import type { mediaApi } from "@apis/media/api";
import type { memoryApi } from "@apis/memory/api";
import type { taxonomyApi } from "@apis/taxonomy/api";

export interface AuthContextValue {
  readonly api: {
    readonly bus: ApiCallers<typeof busApi>;
    readonly generation: ApiCallers<typeof generationApi>;
    readonly github: ApiCallers<typeof githubApi>;
    readonly media: ApiCallers<typeof mediaApi>;
    readonly memory: ApiCallers<typeof memoryApi>;
    readonly oauth: ApiCallers<typeof oauthApi>;
    readonly taxonomy: ApiCallers<typeof taxonomyApi>;
  };
}

export const AuthContext = createContext<AuthContextValue | null>(null);
